import { useGoogleAnalytics } from 'volto-google-analytics';
import type { Content } from '@plone/types';

const AnalyticsSlot = ({ content }: { content: Content }) => {
  useGoogleAnalytics();
  return <span className="analytics-slot"></span>;
};

export default AnalyticsSlot;
